'use strict';

import React from 'react';
import classNames from 'classnames';
import PropTypes  from 'prop-types';

const photoStorageMessage = props => {

  const message = 'Photo accounts are not designed or intended to be used as permanent Photo storage. Please be advised that if your account is inactive for more than 1 year, uploaded photos will be deleted.';

  return (
    <div className={classNames('custom-alert', props.variant, props.isOpen ? 'd-block alert alert-warning' : 'd-none')}>
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={props.onClose}
      >
        <i className="fas fa-times" />
      </button>
      <p className="title d-block d-md-none">Photo Storage Policy</p>
      <p className="content m-lg-0">
        <span className="store-name">{props.storeName}&nbsp;</span>
        {message}
      </p>
    </div>
  );
}
photoStorageMessage.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  storeName: PropTypes.string,
  variant: PropTypes.string,
};

export default photoStorageMessage;
